import React from "react";

import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { buttonClick } from "../../utils/animations";

const Trainers = () => {
  return (
    <div className=" w-full my-8 flex flex-col items-center justify-center">
      <div className="w-full flex items-center justify-between">
        <div></div>
        <p className="text-3xl text-headingColor font-semibold">
          List of Trainers
        </p>
        <NavLink to={"/dashboard/newTrainer"}>
          <motion.div
            {...buttonClick}
            className=" px-5 py-2  rounded-md border border-gray-200 bg-gray-50 cursor-pointer hover:shadow-lg"
          >
            Add New
          </motion.div>
        </NavLink>
      </div>
    </div>
  );
};

export default Trainers;
